import PasswordSettings from './passwordSettings.view';

export default PasswordSettings;
